__turbopack_context__.v({
  "articlesGrid": "ArticlesGrid-module-scss-module__VUQ5Cq__articlesGrid",
  "showBlock": "ArticlesGrid-module-scss-module__VUQ5Cq__showBlock",
});
